import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useValuesChartsDataContext } from './hooks/useValuesChartsDataContext';

export const CalculatedValueWithIncentivesAnual = () => {
    const { chartData } = useValuesChartsDataContext();

    return (
        <SimpleBars
            title={'Valor Calculado Com Incentivos (Anual)'}
            horizontal={false}
            subtitles={chartData?.calculatedValueWithIncentivesAnual?.map((item) => getYearLabel(item.ano))}
            values={chartData?.calculatedValueWithIncentivesAnual?.map((item) => item.value || 0)}
        />
    );
};
